import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { createContext, useContext, useEffect, useState } from 'react';
import { selectAll } from 'unist-util-select';
import { useTabSet } from '@myst-theme/providers';
import { MyST } from './MyST.js';
const TabSetContext = createContext(undefined);
// Create a provider for components to consume and subscribe to changes
function TabSetStateProvider({ active, children }) {
    return _jsx(TabSetContext.Provider, { value: active, children: children });
}
export function TabSet({ tabs, children }) {
    var _a, _b, _c, _d;
    const [lastClickedTab, onClickSyncedTab] = (_a = useTabSet()) !== null && _a !== void 0 ? _a : [];
    const [active, setActive] = useState((_c = (_b = tabs.find((t) => t.selected)) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : (_d = tabs === null || tabs === void 0 ? void 0 : tabs[0]) === null || _d === void 0 ? void 0 : _d.id);
    const onClick = (tab) => {
        setActive(tab.id);
        if (tab.sync) {
            if (!onClickSyncedTab) {
                console.error('TabStateProvider is not defined, synced tabs will not work.');
            }
            onClickSyncedTab === null || onClickSyncedTab === void 0 ? void 0 : onClickSyncedTab(tab.sync);
        }
    };
    useEffect(() => {
        if (!lastClickedTab)
            return;
        const tab = tabs.find((item) => item.sync === lastClickedTab);
        if (!tab)
            return;
        setActive(tab === null || tab === void 0 ? void 0 : tab.id);
    }, [tabs, lastClickedTab, setActive]);
    return (_jsx(TabSetStateProvider, { active: active, children: _jsxs("div", { className: "my-5", children: [_jsx("div", { className: "flex flex-row overflow-x-auto border-b border-b-gray-100", children: tabs.map((tab) => {
                        return (_jsx("div", { className: classNames('flex-none px-3 py-1 font-semibold cursor-pointer', {
                                'text-blue-600 border-b-2 border-b-blue-600 dark:border-b-white dark:text-white': active === tab.id,
                                'text-gray-500 dark:text-gray-300 hover:text-gray-700 dark:hover:text-gray-100': active !== tab.id,
                            }), onClick: () => onClick(tab), children: tab.title }, tab.id));
                    }) }), _jsx("div", { className: "flex shadow", children: _jsx("div", { className: "w-full px-6", children: children }) })] }) }));
}
export function TabItem({ id, children, }) {
    const active = useContext(TabSetContext);
    const open = active === id;
    return _jsx("div", { className: classNames({ hidden: !open }), children: children });
}
export const TabSetRenderer = ({ node }) => {
    // Add the key as the ID (key is special in react)
    const tabs = selectAll('tabItem', node).map((tab) => ({
        title: tab.title,
        id: tab.key,
        sync: tab.sync,
    }));
    return (_jsx(TabSet, { tabs: tabs, children: _jsx(MyST, { ast: node.children }) }));
};
export const TabItemRenderer = ({ node }) => {
    return (_jsx(TabItem, { id: node.key, children: _jsx(MyST, { ast: node.children }) }));
};
const TAB_RENDERERS = {
    tabSet: TabSetRenderer,
    tabItem: TabItemRenderer,
};
export default TAB_RENDERERS;
